import { useIntl } from 'react-intl';
import { ApiCustomField, ApiEnumGroup, ApiOrganization } from '@agunity/api-v4';

import AgLoadingCard from '../../../stories/AgLoadingCard';
import EditOrganizationDetails from './EditOrganizationDetails';
import ViewOrganizationDetails from './ViewOrganizationDetails';

const OrganizationDetails = ({
  identity,
  setOrgDetails,
  editAccess,
  imageURL,
  onImageUpdate,
  showError,
  validationList,
  tagList,
  enumList
}: {
  identity?: ApiOrganization;
  // eslint-disable-next-line no-unused-vars
  setOrgDetails?: (data: ApiOrganization) => void;
  editAccess: boolean;
  imageURL?: string;
  // eslint-disable-next-line no-unused-vars
  onImageUpdate?: (base64?: string) => void;
  showError?: boolean;
  validationList?: {[key: string]: string[]};
  tagList?: ApiCustomField[] | null;
  enumList?: ApiEnumGroup[]
}) => {
  const messages = useIntl().formatMessage;
  return (
    !identity
      ? <AgLoadingCard text={messages({ id: 'LOADING' })} />
      : editAccess
        ? <EditOrganizationDetails
          identity={identity}
          setOrgDetails={setOrgDetails}
          imageURL={imageURL}
          showError={showError}
          validationList={validationList}
          onImageUpdate={onImageUpdate}
          tagList={tagList}
          enumList={enumList}
        />
        : <ViewOrganizationDetails
          identity={identity}
          imageURL={imageURL}
        />
  );
};
 
export default OrganizationDetails;